
/*
*	MG2 Media JS Framework
*	@author  François Vandal
*	@version: 0.9.4
*	Last update: 6 september 2016
*/

(function ($, global, undefined) {
	var html = $('html');
	var lang = html.attr('lang');
	var defaultLang = html.attr('data-default-lang');

	var modules = {};
	var components = {};
	var pages = {};

	const toggleSwitch = document.getElementById('toggle-switch');
	if (toggleSwitch != null && toggleSwitch != undefined) {
		var updateField = toggleSwitch.getAttribute("update-field");

		toggleSwitch.addEventListener('change', function () {
			$("input[name='" + updateField + "']").val(toggleSwitch.checked ? "a" : "i");
		});
	}


	/* Modules */
	var createModule = function (module) {
		return $.extend({
			init: $.noop,
			pageLoad: $.noop,
			pageChange: $.noop,
			pageEnter: $.noop,
			pageLeave: $.noop,
			pageStartChange: $.noop
		}, module);
	};

	var exportModule = function (key, module) {
		modules[key] = createModule(module);

		return modules[key];
	};


	/* Pages */
	var createPage = function (page) {
		return $.extend({
			init: $.noop,
			pageLoad: $.noop,
			pageEnter: $.noop,
			pageLeave: $.noop
		}, page);
	};

	var exportPage = function (key, page) {
		pages[key] = createPage(page);

		return pages[key];
	};

	var checkForPage = function (pageIdNum) {
		var currPage = $('.main-content .page[data-page-id-num=' + pageIdNum + ']').attr('data-page-id');

		if (pages[pageIdNum] !== undefined) {
			pages[pageIdNum].init('#page-' + currPage);
			pages[pageIdNum].pageLoad('#page-' + currPage);
		}
	};


	/* Components */
	var createComponent = function (component) {
		return $.extend({ init: $.noop }, component);
	};

	var exportComponent = function (key, component) {
		components[key] = createPage(component);

		return pages[key];
	};


	var start = function () {
		var lang = $('html').attr('lang');
		var defaultLang = $('html').attr('data-default-lang');

		var currPathname = location.pathname;
		var currentIdNum = $('.main-content .page').data('pageIdNum');

		if (currPathname !== '/' && currPathname.substring(0, 1) === '/') {
			currPathname = currPathname.substring(1);
		}

		if (lang !== defaultLang) {
			currPathname = currPathname.substring(lang.length);
		}

		currPathname = currPathname !== '/' ? currPathname : 'home';

		if (currPathname.substring(currPathname.length - 1) === '/') {
			currPathname = currPathname + 'home';
		}

		if (currPathname.substring(0, 1) === '/') {
			currPathname = currPathname.substring(1);
		}

		currPathname = currPathname.split('?')[0];
		if (currPathname.substring(currPathname.length - 1) === '/') {
			currPathname = currPathname.substring(0, currPathname.length - 1);
		}

		if (lang !== defaultLang) {
			if (currPathname.substring(0, lang.length) === lang) {
				currPathname = currPathname.substring(lang.length);
			}
		}

		if (currPathname.substring(0, 1) === '/') {
			currPathname = currPathname.substring(1);
		}

		currPathname = currPathname.split('/')[0];

		$.each(Fw.modules.models(), function () {
			this.init('body');
			this.pageLoad('body');
		});

		$('html').attr('data-curr-page', 'page-' + currPathname);
		checkForPage(currentIdNum);

		return Fw;
	};

	global.Fw = $.extend(global.Fw, {
		data: '',

		modules: {
			models: function () {
				return modules;
			},

			export: exportModule
		},

		component: {
			models: function () {
				return components;
			},

			export: exportComponent
		},

		page: {
			models: function () {
				return pages;
			},

			export: exportPage,

			checkForPage: checkForPage
		},

		start: start
	});

	window.cloneCoordsTemplate = function (coordsData) {
		var itemTemplate = $(".add-modify-page-inner-geofence-ctn-location-item-template");
		var id = $(".add-modify-page-inner-geofence-ctn-location-item").length + 1;
		var clone = itemTemplate.clone();
		clone.removeClass("add-modify-page-inner-geofence-ctn-location-item-template").addClass("add-modify-page-inner-geofence-ctn-location-item");
		clone.attr("id", "buildingId" + id);
		clone.attr("geofence-data", coordsData.coords);
		clone.find(".first").html(coordsData.name);
		clone.show();

		clone.appendTo("#geofence-list-inner");
		return clone;
	}

	// window.addNFCInInput=function(id,div){
	// try {
	// 	var jsonObject = JSON.parse($("input[name='nfcs-details']").val());

	// 	jsonObject[`${id}`]={deleted:false,field31:div.parent().parent().parent().parent().attr("data-id")};

	// 	$("input[name='nfcs-details']").val(JSON.stringify(jsonObject));
	// } catch (error) {
	// 	var jsonObject = {};

	// 	jsonObject[`${id}`]={deleted:false,field31:div.parent().parent().parent().parent().attr("data-id")};

	// 	$("input[name='nfcs-details']").val(JSON.stringify(jsonObject));
	// }
	// }

	window.updateNFCSelects = function () {
		const ids = $(`.js-nfc-list-item-delete`).map((_, el) => Number(el.dataset.id)).get();
		$('[name="nfc-tag"] option').prop('disabled', false).show();
		ids.forEach(id => {
			$(`[name="nfc-tag"] option[value="${id}"]`).prop('disabled', true).hide();
		});
	}

	window.onRemoveNFCClick = function ({ currentTarget }) {
		const li = $(currentTarget).closest('li');
		const id = li.find(".js-nfc-list-item-delete").attr("data-id");
		li.remove();

		window.parent.updateNFCSelects();
	}
	window.updateHiddenSelect2 = function (item) {
		var selects = item.find(".form-select-ctn");

		$(selects).each((i, el) => {
			var selectDiv = $(el);

			var id = selectDiv.find(".updated-select-input").attr("id");
			var name = selectDiv.find(".updated-select-input").attr("name");
			var dataId = selectDiv.find(".updated-select-input").attr("data-id");
			var dataExtra = selectDiv.find(".updated-select-input").attr("data-extra");
			var isRequired = selectDiv.find(".updated-select-input").hasClass("required");
			var disabled = selectDiv.find(".updated-select-input").attr("disabled");

			selectDiv.find(".updated-select-input").remove();

			selectDiv.find(".select2.select2-container.select2-container--default").remove();

			var select = selectDiv.find(".updated-select-input-hidden").clone();
			select.removeClass("updated-select-input-hidden").addClass("updated-select-input");

			if (id !== undefined)
				select.attr("id", id);
			if (name !== undefined) {
				select.attr("name", name);
			} if (dataId !== undefined)
				select.attr("data-id", dataId);
			if (dataExtra !== undefined)
				select.attr("data-extra", dataExtra);
			if (isRequired)
				select.addClass("required");
			if (disabled !== undefined)
				select.attr("disabled", disabled);

			select.addClass("form-select form-input");
			select.removeClass("updated-select-input-hidden").addClass("updated-select-input");
			select.appendTo(selectDiv);

			window.parent.initializeSelect2(select);
		});
	}

	window.updateHiddenSelect = function (item, newId) {
		var selectDiv = $(item).find(".form-select-ctn");

		var id = selectDiv.find(".updated-select-input").attr("id");
		var name = selectDiv.find(".updated-select-input").attr("name");
		var dataId = selectDiv.find(".updated-select-input").attr("data-id");
		var dataExtra = selectDiv.find(".updated-select-input").attr("data-extra");
		var isRequired = selectDiv.find(".updated-select-input").hasClass("required");
		var disabled = selectDiv.find(".updated-select-input").attr("disabled");

		selectDiv.find(".updated-select-input").remove();

		selectDiv.find(".select2.select2-container.select2-container--default").remove();

		var select = selectDiv.find(".updated-select-input-hidden").clone();
		select.removeClass("updated-select-input-hidden").addClass("updated-select-input");

		if (id !== undefined)
			select.attr("id", id + "-" + newId);
		if (name !== undefined) {
			select.attr("name", name);
		} if (dataId !== undefined)
			select.attr("data-id", dataId);
		if (dataExtra !== undefined)
			select.attr("data-extra", dataExtra);
		if (isRequired)
			select.addClass("required");
		if (disabled !== undefined)
			select.attr("disabled", disabled);
		select.addClass("form-select form-input");

		var isRequired = selectDiv.find(".updated-select-input").hasClass("required");
		var disabled = selectDiv.find(".updated-select-input").attr("disabled");

		select.appendTo(selectDiv);
		window.parent.initializeSelect2(select);
	}

	window.addComponent = function (dropdownOption, containerId) {
		return window.parent.addGenComponent(dropdownOption, "responseOption", "containerId" + containerId, "response-type-container-item", ".add-response-edit-location", null);
	}

	window.addPictureComponent = function (filename, containerId, filenameGen) {
		var id = window.parent.addGenComponent(filename, "pictureLi", "pictureContainerId" + containerId, "picture-container-item", ".add-picture-edit-location", filenameGen);
		return id;
	}

	window.addGenComponent = function (cName, cPrefix, containerId, containerCls, editBtnCls, cFilename) {
		var container = $("." + containerId);
		var totalEle = container.find("." + containerCls).length;
		var cClone = $("." + containerCls + "-hidden").clone();
		var textBoxId = cPrefix + totalEle + containerId;
		cClone.removeClass(containerCls + "-hidden").addClass(containerCls);

		cClone.find(".first").html(cName);
		cClone.find(".first").addClass(textBoxId);
		cClone.find(editBtnCls).attr("data-str-box-id", textBoxId);

		if (cFilename)
			cClone.find(editBtnCls).attr("data-filename", cFilename);

		container.append(cClone);
		return textBoxId;
	}


	var convertDivToBase64Image = function (divId, width, height) {
		return new Promise((resolve, reject) => {
			const tableDiv = document.getElementById(divId);
			if (!tableDiv) {
				console.error(`Element with ID ${divId} not found`);
				resolve(null);
				return;
			}

			const svgElement = tableDiv.querySelector("svg");

			if (svgElement) {
				// ✅ Handle SVG Conversion
				try {
					const svgString = new XMLSerializer().serializeToString(svgElement);
					const base64 = btoa(unescape(encodeURIComponent(svgString)));
					const svgData = `data:image/svg+xml;base64,${base64}`;

					var canvas = document.createElement("canvas");
					var context = canvas.getContext("2d");

					canvas.width = width;
					canvas.height = height;

					var image = new Image();

					image.onload = function () {
						context.clearRect(0, 0, width, height);
						context.drawImage(image, 0, 0, width, height);
						var pngData = canvas.toDataURL("image/png");
						resolve(pngData);
					};

					image.onerror = function () {
						console.error("Error loading SVG image");
						resolve(null);
					};

					image.src = svgData;
				} catch (error) {
					console.error("Error converting SVG to Base64:", error);
					resolve(null);
				}
			} else {
				// ✅ Handle HTML Elements using `html2canvas`
				html2canvas(tableDiv, {
					backgroundColor: null, // Transparent background
					width: width,
					height: height,
					scale: 2, // High-resolution capture
				}).then((canvas) => {
					resolve(canvas.toDataURL("image/png"));
				}).catch((error) => {
					console.error("Error capturing div with html2canvas:", error);
					resolve(null);
				});
			}
		});
	};

	$(document).on("click", ".dt-download-btn", async function (e) {
		const btn = $(e.currentTarget);
		const table = $("#" + btn.attr("aria-controls"));
		const chart = table.attr("chart");

		const img = await convertDivToBase64Image(chart, 1280, 900);
		var image = new Image();
		image.src = img;
		image.id = btn.attr("aria-controls") + "-chartImg";
		image.classList.add("d-none");

		if (table.find("#" + btn.attr("aria-controls") + "-chartImg"))
			table.find("#" + btn.attr("aria-controls") + "-chartImg").remove();

		table.prepend(image);
	});

	window.initializeISelectMultiple = function (select, field, viewField, prefix, postfix) {

		// This is your onChange callback.
		function treeOnChange(allSelectedItems, addedItems, removedItems) {
			if (viewField !== undefined) {
				// Set total selected items on view field.
				$(viewField).val(prefix + allSelectedItems.length + postfix);
			}
			if (field !== undefined) {
				// Set total selected items ids on hidden input field.
				$(field).val(allSelectedItems.map(obj => obj.value).join(","));

				populateUsersOnLocations(field);
			}
		}

		// Initialize the treeMultiselect.
		$(select ? select : ".iselect-multiple").treeMultiselect({
			searchable: true,
			searchParams: ['section', 'text'],
			onChange: treeOnChange,
			startCollapsed: true,
			enableSelectAll: true
		});

		// Run the populate function on page load as well.
		populateUsersOnLocations(field);
	};

	function populateUsersOnLocations(field) {
		if (field === "#rChecklists") {
			var checkedLabels = [];

			// Assuming the tree-multiselect container is the div immediately following #checklistsList2.
			$('#checklistsList2')
				.next('div')
				.find('.title')
				.each(function () {
					var $checkbox = $(this).find('input[type="checkbox"]');
					if ($checkbox.is(':checked') || $checkbox.prop("indeterminate")) {
						// Collect the trimmed text from each .title.
						checkedLabels.push($.trim($(this).text()));
					}
				});

			// Create a comma-separated string from the checked labels.
			var checkedString = checkedLabels.join(',');

			$.ajax({
				url: '/action/sbReminderUsers',
				type: 'POST',
				data: { Locations: checkedString },
				success: function (response) {

					var isMultiple = checkedString.indexOf(',') !== -1;
					var heading;

					if (document.documentElement.lang === 'fr') {
						heading = "Utilisateurs de l'emplacement" + (isMultiple ? "s" : "");
					} else {
						heading = (isMultiple ? "Locations" : "Location") + " Users";
					}

					var headingHtml = '<p><strong>' + heading + '</strong></p>';



					// If the response is empty ("" or empty array), display only the heading.
					if (!response  || (response.length === 0 || !Array.isArray(response))) {
						$('#response-forward__persons').html(headingHtml);
						return;
					}

					// Sort the response array by full_name (alphabetically, case-insensitive)
					response.sort(function (a, b) {
						var nameA = a.full_name.toUpperCase();
						var nameB = b.full_name.toUpperCase();
						if (nameA < nameB) return -1;
						if (nameA > nameB) return 1;
						return 0;
					});

					// Start building the HTML output.
					var html = headingHtml;

					// Iterate through each user in the sorted response.
					$.each(response, function (index, user) {
						html += '<label class="form-checkbox-ctn response-forward__person rf-person-row">';

						// Add the toggle button as the very first element.
						html += '<span class="toggle-arrow rf-toggle-arrow">+</span>';

						// Build the checkbox input.
						html += '<input type="checkbox" class="form-check-input response-forward__person-check reminder-field" ' +
							'name="response-forward-person" ' +
							'data-field1="' + user.person_id + '" ' +
							'data-field2="' + user.email + '" ' +
							'value="' + user.email + ' - ' + user.locations + '">';

						// Add the span for the checkbox graphic (using your SVG).
						html += '<span class="form-checkbox rf-checkbox-icon">';
						html += '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" width="33.65px" height="25.86px" viewBox="0 0 33.65 25.86" xml:space="preserve">';
						html += '<polyline fill="none" stroke="#000000" stroke-width="8" stroke-miterlimit="10" points="2.7,11.21 12.7,20.38 30.87,2.88"></polyline>';
						html += '</svg>';
						html += '</span>';

						// Build the text span: show the full name only on the main label.
						html += '<span class="rf-person-name">';
						html += '<strong>' + user.full_name + '</strong>';
						html += '</span>';

						// Build the tree view container which will include the email and locations.
						var treeHtml = '<ul class="rf-tree-list">';
						// First list item: the email with a bottom border acting as a separator.
						treeHtml += '<li class="rf-tree-email">' + user.email + '</li>';
						// Next, split the locations string into an array and list them.
						var locArray = user.locations.split(',');
						$.each(locArray, function (i, loc) {
							treeHtml += '<li>' + $.trim(loc) + '</li>';
						});
						treeHtml += '</ul>';

						// Add the locations container (initially hidden) containing the tree view.
						html += '<div class="locations-container rf-locations-container">' + treeHtml + '</div>';

						html += '</label>';
					});

					// Insert the generated HTML into the container.
					$('#response-forward__persons').html(html);
				},
				error: function (xhr, status, error) {
					console.error('AJAX call failed:', error);
				}
			});
		}
	}

	$(document).on('click', '.toggle-arrow', function (e) {
		e.preventDefault();
		e.stopPropagation();
	
		var $this = $(this);
		var $container = $this.closest('.parent-class').find('.locations-container');
	
		// Check current state before toggling
		if ($container.is(':visible')) {
			$container.slideUp('fast');
			$this.text("+");
		} else {
			$container.slideDown('fast');
			$this.text("–");
		}
	});

	function formatDate(dateStr) {
		// Remove ordinal suffixes (st, nd, rd, th)
		const sanitizedDateStr = dateStr.replace(/\b(\d{1,2})(st|nd|rd|th)\b/, "$1");
	
		// Parse the cleaned date string
		const date = new Date(sanitizedDateStr);
	
		// Check if the date is valid
		if (isNaN(date.getTime())) {
			console.error("Invalid date format:", dateStr);
			return "Invalid Date";
		}
	
		const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
		const day = ("0" + date.getDate()).slice(-2);
		const month = monthNames[date.getMonth()];
		const year = date.getFullYear();
	
		return `${month}${day}-${year}`;
	}

	function buildPdfPayload(table, dt) {
		const title = (table.attr("report-title") || document.title || "Report").trim();
		const logoImage = $("#logoBase64").attr("src") || null;
		const chartImage = $("#" + table.attr("id") + "-chartImg").attr("src") || null;
		const headers = dt.columns().header().toArray().map(function (header) {
			return $(header).text().trim();
		});
		const rows = dt.rows({ search: "applied" }).data().toArray();

		const normalizedRows = rows.map(function (row) {
			if (Array.isArray(row)) {
				return headers.reduce(function (acc, header, index) {
					acc[header || ("Column " + (index + 1))] = row[index] == null ? "" : String(row[index]);
					return acc;
				}, {});
			}
			if (row && typeof row === "object") {
				return row;
			}
			return { Value: row == null ? "" : String(row) };
		});

		return {
			logoImage: logoImage,
			chartImage: chartImage,
			reportTitle: title,
			table: normalizedRows
		};
	}

	function buildIncidentPdfPayload(dt) {
		const dateRangeValue = $("#incident_rangeDate").val() || "";
		const chartImage = window.incidentChart && typeof window.incidentChart.getImageURI === "function"
			? window.incidentChart.getImageURI()
			: null;
		const legend = Array.isArray(window.incidentReports) && Array.isArray(window.incidentColors)
			? window.incidentReports.map(function (item, idx) {
				return {
					incidentType: item.incidentType,
					count: item.count,
					color: window.incidentColors[idx % window.incidentColors.length]
				};
			})
			: [];
		const tableData = dt.rows({ search: "applied" }).data().toArray().map(function (row) {
			return {
				dateRange: dateRangeValue,
				locationName: row.locationName || "",
				incidentType: row.incidentType || "",
				count: row.count || 0
			};
		});

		return {
			chartImage: chartImage,
			legend: legend,
			table: tableData
		};
	}

	function buildShiftPdfPayload(dt) {
		const chartImage = window.shiftChart && typeof window.shiftChart.getImageURI === "function"
			? window.shiftChart.getImageURI()
			: null;
		return {
			chartImage: chartImage,
			type: window.shiftType != null ? window.shiftType : ($("#shift-type-dropdown").val() || "0"),
			table: dt.rows({ search: "applied" }).data().toArray(),
			dateRange: $("#shift_rangeDate").val() || ""
		};
	}

	function resolvePdfExportConfig(table, dt) {
		const tableId = (table.attr("id") || "").toLowerCase();
		const reportTitle = (table.attr("report-title") || "").toLowerCase();

		if (tableId === "incidenttable" || reportTitle.indexOf("incident") !== -1) {
			return {
				endpoint: "/action/generate-incident-pdf",
				fileName: "IncidentReport.pdf",
				payload: buildIncidentPdfPayload(dt)
			};
		}

		if (tableId === "shifttable" || reportTitle.indexOf("shift") !== -1) {
			return {
				endpoint: "/action/generate-shift-pdf",
				fileName: "DailyShiftReport.pdf",
				payload: buildShiftPdfPayload(dt)
			};
		}

		const checklistPayload = buildPdfPayload(table, dt);
		return {
			endpoint: "/action/generate-checklist-pdf",
			fileName: (checklistPayload.reportTitle || "Report").replace(/[\\/:*?"<>|]+/g, "_") + ".pdf",
			payload: checklistPayload
		};
	}

	function exportTablePdf(table, dt) {
		const exportConfig = resolvePdfExportConfig(table, dt);

		fetch(exportConfig.endpoint, {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(exportConfig.payload)
		})
			.then(function (response) {
				if (!response.ok) {
					throw new Error("HTTP " + response.status);
				}
				return response.blob();
			})
			.then(function (blob) {
				const url = window.URL.createObjectURL(blob);
				const anchor = document.createElement("a");
				anchor.href = url;
				anchor.download = exportConfig.fileName;
				document.body.appendChild(anchor);
				anchor.click();
				anchor.remove();
				window.URL.revokeObjectURL(url);
			})
			.catch(function (error) {
				console.error("Failed to export PDF:", error);
				alert("Failed to generate PDF.");
			});
	}

	window.initializeDataTable = function (table) {
		if ($.fn.DataTable.isDataTable(table)) { 
			table.DataTable().destroy(); // ✅ Destroy previous instance
		}	
		if (table.hasClass("with-chart"))
			return table.DataTable({
				lengthMenu: [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]],
				layout: {
					topStart: {
						buttons: ["pageLength",
							{
								extend: 'collection',
								text: 'Download',
								attr: {
									class: "dt-button buttons-collection dt-download-btn",
								},
								buttons: ['excelHtml5', 'csvHtml5', {
									text: "Export PDF",
									action: function (e, dt) {
										exportTablePdf(table, dt);
									}
								}]
							}
						]
					}
				}
			});
		else
			return table.DataTable({
				lengthMenu: [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]],
				layout: {
					topStart: {
						buttons: ["pageLength",
							{
								extend: 'collection',
								text: 'Download',
								buttons: ['excelHtml5', 'csvHtml5', {
									text: "Export PDF",
									action: function (e, dt) {
										exportTablePdf(table, dt);
									}
								}]
							}
						]
					}
				}
			});
	};


	window.filterByJson = function (searchTerm, table, tableId) {
		searchTerm = String(searchTerm).toLowerCase();
		$.fn.dataTable.ext.search.push(
			function (settings, data, dataIndex) {
				if (settings.nTable.id !== tableId) {
					for (var i = 0; i < data.length; i++) {
						if (data[i].toLowerCase().includes(searchTerm)) {
							return true;
						}
					}
				} else {
					try {
						var rowNode = settings.aoData[dataIndex].nTr;
						var questions = JSON.parse(JSON.parse($(rowNode).data('json'))).questions;
						var questionsStr = String(questions.map((u) => u.name).join(",")).toLowerCase();

						if (questionsStr.includes(searchTerm)) {
							return true;
						}

						for (var i = 0; i < data.length; i++) {
							if (data[i].toLowerCase().includes(searchTerm)) {
								return true;
							}
						}
					} catch (error) {
						for (var i = 0; i < data.length; i++) {
							if (data[i].toLowerCase().includes(searchTerm)) {
								return true;
							}
						}
					}
				}
			}
		);
		table.draw();
		$.fn.dataTable.ext.search.pop();
	}
	window.initializeMultiSelect2 = function (select) {

		function stripDiacritics(text) {
			function match(a) {
				return DIACRITICS[a] || a;
			}

			return text.replace(/[^\u0000-\u007E]/g, match);
		}

		function matcher(params, data) {
			if (params.term == null || params.term.trim() === '') {
				return data;
			}

			if (data.children && data.children.length > 0) {
				var match = $.extend(true, {}, data);

				for (var c = data.children.length - 1; c >= 0; c--) {
					var child = data.children[c];

					var matches = matcher(params, child);

					if (matches == null) {
						match.children.splice(c, 1);
					}
				}

				if (match.children.length > 0) {
					return match;
				}

				return matcher(params, match);
			}

			var original = stripDiacritics(data.text).toUpperCase();
			var term = stripDiacritics(params.term).toUpperCase();

			if (original.indexOf(term) > -1) {
				return data;
			}
			return null;
		}

		function checkboxWithOpt(state, classes, inputsSelected) {
			var id = state.id ? state.id.toLowerCase() : state.element.getAttribute("value");

			var label = '<label for="' + id + '">' + state.text + '</label>';
			var selected = state.selected;

			if (state.children)
				if (inputsSelected) {
					const inputSelected = inputsSelected.get('optgroup-' + id + "-input");

					if (inputSelected != undefined && inputSelected.id != undefined && inputSelected.id == 'optgroup-' + id + "-input") {
						selected = inputSelected.selected;
					}
				}

			return $(
				'<div class="sb-readonly-checkbox' + (state.children ? ' sb-cursor-pointer optgroup-checkbox" '
					+ 'select-id="' + $(state.element).parent().attr("id") + '" parent-id="optgroup-' + id : ' option-checkbox" '
					+ 'parent-id="optgroup-' + $(state.element).parent().attr("value")) + '">'

				+ '<div class="sb-readonly-checkbox-inner"></div>'
				+ '<div class="sb-d-flex">'
				+ '<div class="sb-flex1">'
				+ '<input ' + (selected ? 'checked="checkekd"' : '') + ' data-id="' + id + '" type="checkbox" class="' + classes + '" ' +
				(state.children ? ' id="optgroup-' + id + '-input"' : 'id="optioncheckbox-' + id + '"') + '>'
				+ '</div>'
				+ '<div class="sb-flex99">'
				+ label
				+ "</div>"
				+ "</div>"
				+ '</div>');
		}

		function callSelect2(select, inputsSelected) {
			select.select2({
				dropdownAutoWidth: true,
				width: '100%',
				matcher: matcher,
				templateResult: (state) => {
					if (!state.id) {
						if (state.children) {
							return checkboxWithOpt(state, 'optgroup-checkbox', inputsSelected);
						} else
							return state.text;
					}
					return checkboxWithOpt(state, "optgroup-" + $(state.element).parent().attr("value"), inputsSelected);
				},
				templateSelection: (state) => {
					const id = state.id;
					$("#optioncheckbox-" + String(id).toLocaleLowerCase()).attr("checked", true);
					return state.text;
				},
				closeOnSelect: false,
				escapeMarkup: function (m) {
					return m;
				},
			}).on('select2:unselect', function (e) {
				var data = e.params.data;
				$("#optioncheckbox-" + String(data.id).toLocaleLowerCase()).attr("checked", false);
			});

			var container = $(select).siblings('.select2-container');
			$(container).find(".select2-selection").css({
				'min-height': '47px', 'border': '1px solid #cbccd9',
				'background-color': 'inherit', 'font-size': '1.4rem',
				'font-family': 'Lato,arial,helvetica,sans-serif'
			});
			$(container).find('.select2-selection__arrow').css({ 'height': '44px', 'right': '10' });
		}

		callSelect2(select);

		$(document).on("click", ".option-checkbox", function (e) {
			const option = $(e.currentTarget);
			const id = option.attr("parent-id");
			const parentDiv = $("optgroup[value='" + String(id).replace("optgroup-", "") + "']");
			const parentDivInput = $("#" + id + "-input");
			const children = $("." + id + ":checked");
			console.warn(children.length + ":" + parentDiv.children().length);
			if (children)
				parentDivInput.prop("checked", children.length == parentDiv.children().length)
		});

		$(document).on("click", ".optgroup-checkbox", function (e) {
			const parentDiv = $(e.currentTarget)
			const id = parentDiv.attr("parent-id");
			const selectId = parentDiv.attr("select-id");
			const children = $("." + id);
			const parentDivInput = $("#" + id + "-input")
			const checked = parentDivInput.prop("checked");

			if (children) {
				children.prop("checked", !checked);

				var optgroups = new Map();
				$(".optgroup-checkbox").each((i, e) => {
					var nI = $(e).attr("id");
					if (nI != undefined && !optgroups.has(id))
						optgroups.set(nI, { id: nI, selected: nI == id + "-input" ? !checked : $(e).prop("checked") });
				});

				if (checked) {
					var unselectValues = children.map(function (i, v) {
						return String($(v).attr("data-id")).toUpperCase();
					}).get();

					var selectedValues = $('#' + selectId).val().filter((v) => {
						return !unselectValues.includes(v);
					});

					callSelect2($('#' + selectId).val(selectedValues), optgroups)
				} else {
					var selectedValues = [];
					children.each((i, v) => {
						selectedValues.push(String($(v).attr("data-id")).toUpperCase());
					});

					callSelect2($('#' + selectId).val($('#' + selectId).val().concat(selectedValues)), optgroups);
				}
			}
		});

		$(document).on("click", ".optgroup-checkbox", function (e) {
			const parentDiv = $(e.currentTarget)
			const id = parentDiv.attr("parent-id");
			const selectId = parentDiv.attr("select-id");
			const children = $("." + id);
			const parentDivInput = $("#" + id + "-input")
			const checked = parentDivInput.prop("checked");

			if (children) {
				children.prop("checked", !checked);

				var optgroups = new Map();
				$(".optgroup-checkbox").each((i, e) => {
					var nI = $(e).attr("id");
					if (nI != undefined && !optgroups.has(id))
						optgroups.set(nI, { id: nI, selected: nI == id + "-input" ? !checked : $(e).prop("checked") });
				});

				if (checked) {
					var unselectValues = children.map(function (i, v) {
						return String($(v).attr("data-id")).toUpperCase();
					}).get();

					var selectedValues = $('#' + selectId).val().filter((v) => {
						console.warn(v);
						return !unselectValues.includes(v);
					});

					callSelect2($('#' + selectId).val(selectedValues), optgroups)
				} else {
					var selectedValues = [];
					children.each((i, v) => {
						selectedValues.push(String($(v).attr("data-id")).toUpperCase());
					});

					callSelect2($('#' + selectId).val($('#' + selectId).val().concat(selectedValues)), optgroups);
				}
			}
		});

		callSelect2(select);
	}

	window.initializeSelect2 = function (select) {
		var disableOrderwise = select.attr("disable-orderwise");
		var dataOptions = select.attr("dataoptions");
		var selectedoption = select.attr("selectedoption");
		if (dataOptions != undefined && dataOptions != null && dataOptions) {
			dataOptions = JSON.parse(dataOptions);

			for (var i = 0; i < dataOptions.length; i++) {
				var strrr = (selectedoption != undefined && selectedoption != null && selectedoption == dataOptions[i] ? "selected='selected'" : "");
				select.append("<option value='" + dataOptions[i] + "' " + strrr + ">" + dataOptions[i] + "</option>");
			}
		}

		if (disableOrderwise == 'true') {
			if ($(select).hasClass("select2-multiple"))
				window.parent.initializeMultiSelect2(select);
			else
				select.select2();
		} else {
			if ($(select).hasClass("select2-multiple"))
				window.parent.initializeMultiSelect2(select);
			else
				select.select2({
					sorter: data => {
						var firstItem = data.shift();
						var tempData = data.sort((a, b) => a.text.localeCompare(b.text));
						tempData.unshift(firstItem);
						return tempData;
					}
				});
		}

		var container = $(select).siblings('.select2-container');
		if (!($(select).hasClass("select2-multiple"))) {
			if ($(select).parent().hasClass("sb-w100")) {
				container.addClass("sb-100w");
			} else if ($(select).parent().hasClass("half") || $(select).parent().parent().hasClass("half")) {
				container.css({ 'display': 'block', 'max-width': '100%', 'width': '100%', 'min-width': '100%' });
			} else if ($(select).parent().hasClass("two-third") || $(select).parent().hasClass("third")) {
				container.css({ 'max-width': '100%', "width": "100%" });
			} else if ($(select).parent().hasClass("sb-150px")) {
				container.css({ "width": "150px" });
			} else {
				container.css({
					'width':
						$(select).parent().hasClass("fill") || $(select).parent().parent().hasClass("fill") ?
							'100%' : $(select).css('width') == '' || $(select).css('width') == '1px' ?
								($(select).css('min-width') == '' ? select.css('max-width') : select.css('min-width')) : $(select).css('width')
				});
			}
			$(container).find(".select2-selection").css({ 'height': '47px', 'border': '1px solid #cbccd9', 'background-color': 'inherit', 'font-size': '1.4rem', 'font-family': 'Lato,arial,helvetica,sans-serif' });
			$(container).find('.select2-selection__arrow').css({ 'height': '44px', 'right': '10' });
			$(container).find('.select2-selection__rendered').css({ 'line-height': '44px', 'padding-left': '18px' });
		}
	}
})(jQuery, window);